import gsap from "gsap";
import ScrollTriggerController from "./scroll-trigger_controller";

export default class ParallaxController extends ScrollTriggerController {

    static values = {
        fromYPercent: { type: Number, default: 10 },
        toYPercent:   { type: Number, default: -10 },
        ease:         { type: String, default: 'none' },
        start:        { type: String, default: 'top bottom' },
        end:          { type: String, default: 'bottom top' },
        scrub:        { type: Number, default: 1 },
    };

    static targets = [
        'parallaxObject',
    ];

    ctx;

    connect() {
        this.ctx = gsap.context(() => {
            gsap.fromTo(this.parallaxObjectTargets,
                {
                    yPercent: this.fromYPercentValue,
                },
                {
                    yPercent: this.toYPercentValue,
                    ease:     this.easeValue,
                    scrollTrigger: {
                        trigger: this.element,
                        start:   this.startValue,
                        end:     this.endValue,
                        scrub:   this.scrubValue,
                    },
                }
            );
        }, this.element);
    }

    disconnect() {
        this.ctx?.revert();
        this.ctx = null;
    }
}
